var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Video'),_c('Biographie'),_c('TransitionBio'),_c('Dates'),_c('TransitionDates'),_c('VideoGallery'),_c('TransitionVideo'),_c('Artistes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }